import React from 'react';
import { Box, FormControlLabel, Radio } from '@material-ui/core';
import ViewerErrorBoundary from '../../../common/ViewerConclusion/ViewerErrorBoundary';
import { QuestionText, StyledRadioGroup } from '../../QuestionViewer.styles';
const BooleanQuestionViewer = ({ componentValues, answer, setAnswer, disabled }) => {
    const handleChange = (event) => {
        setAnswer(event.target.value);
    };
    return (React.createElement(ViewerErrorBoundary, null,
        React.createElement(QuestionText, null, componentValues === null || componentValues === void 0 ? void 0 : componentValues.question),
        React.createElement(Box, { display: "flex", flexDirection: "column" },
            React.createElement(StyledRadioGroup, { "aria-label": "true-or-false-answer", name: "boolean-answer", value: answer !== null && answer !== void 0 ? answer : '', onChange: handleChange },
                React.createElement(FormControlLabel, { value: 'true', control: React.createElement(Radio, { color: "primary" }), label: "True", disabled: disabled }),
                React.createElement(FormControlLabel, { value: 'false', control: React.createElement(Radio, { color: "primary" }), label: "False", disabled: disabled })))));
};
export default BooleanQuestionViewer;
//# sourceMappingURL=index.js.map